import type { ReactElement } from 'react'
import { recommendationsApi } from '../../../api/recommendations'
import { useProfileGate } from '../../../hooks/useProfileGate'
import { COLORS } from '../../../styles/variables'
import { StyledBadge } from '../../ui-kit'

type RecommendationsNavBadgeProps = {
  children: ReactElement
  mode?: 'dot' | 'count'
}

export const RecommendationsNavBadge = ({ children, mode = 'dot' }: RecommendationsNavBadgeProps) => {
  const { isProfileReady } = useProfileGate()
  const { data, isError } = recommendationsApi.useGetRecommendationsSummaryQuery(undefined, {
    skip: !isProfileReady,
    refetchOnFocus: true,
    refetchOnReconnect: true,
  })

  const count = data?.total_count ?? 0
  const visible = !isError && data?.has_recommendations === true && count > 0

  return (
    <StyledBadge
      overlap="circular"
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      variant={mode === 'dot' ? 'dot' : undefined}
      badgeContent={mode === 'count' ? count : undefined}
      invisible={!visible}
      colorBadge={COLORS.CADMIUM_RED}
      size={mode === 'dot' ? 8 : 18}
      max={9}
    >
      {children}
    </StyledBadge>
  )
}
